<div *sondermindMediaQueryIf="'gt-sm'" fxLayout="row" fxLayoutAlign="space-between center" class="close-desktop">
  <h4 class="iris-h4-responsive">Add your profile picture</h4>
  <mat-icon (click)="cancelUpload('close')">close</mat-icon>
</div>

<div *sondermindMediaQueryIf="'lt-md'" class="close-mobile" (click)="cancelUpload('close')"><mat-icon>close</mat-icon></div>

<span class="helper-text">
  Your photo should be clear and professional-looking. Choose a photo that is at least 500 x 500 pixels.
</span>
<div class="modal-container">
  <div sondermindMediaQueryAttribute class="image-background" fxLayout fxLayoutAlign="center center">
    <img #cropimage [src]="data.image.src" class="selected-image" alt=""/>
    <input data-test="image-upload-input" #imageUploadInput type="file" [class.hide]="true" (change)="photoChosen($event)" accept="image/*">
</div>
</div>
